<template>
<div>
        <h2 class="text-center text-primary">Танзими барномаи планшет</h2>


 

    <div class="row">

             
                <div class="col-sm-8">


    <div class="card shadow">
  <div class="card-header bg-primary text-white">
            Истифодабаранда
  </div>
  <div class="card-body">

            <div class="form-group">
                
                <table class="table">
                    <thead>
                        <tr>
                            <th>Ному насаб</th>
                            <th>Телефон</th>
                            <th>Логин</th>
                            <th>Парол</th>
                            <th>Санаи пайвастшавӣ</th>
                        </tr>


                    </thead>

                    <tbody>

<tr v-for="l in list" :key="l">
<td>
{{l.fio}}

</td>

<td>
{{l.phone}}

</td>

<td>
{{l.login}}

</td>
<td>
{{l.pass}}

</td>
<td>
{{l.data}}

</td>

</tr>

                    </tbody>
                </table>
            </div>
      
        </div>
    </div>


  </div>


        <div class="col-sm-4">

    <div class="card shadow">
                <div class="card-header bg-primary text-white">
            Барнома барои планшет
  </div>
  <div class="card-body">

<a target="_blank" href="http://jamback.stat.tj/files/jamoatbook.apk" >JamoatBook</a>

 
        </div>
    </div>
</div>






</div>

 

    <button type="button" @click="save" class="btn btn-primary mt-3">Сабткунӣ</button>


 
</div>
</template>



<script>
 

export default {

data(){

    return{

        list:[
{fio:"Валиев Фарҳод",phone:"927851145",login:"user1", pass:"321", data:"29-03-2023"},
{fio:"",phone:"927777777",login:"user2", pass:"321", data:"29-03-2023"},
{fio:"",phone:"927777777",login:"user3", pass:"321", data:"29-03-2023"},
{fio:"",phone:"927777777",login:"user4", pass:"321", data:"29-03-2023"},

        ]

    }
},

 methods:{

async GetUsers(terid){

console.log('start report3');
try{
                    await this.$api("/api/summary/"+5+"/"+terid+" /")
                   // .then(res => res.json())
                    .then(data => this.list=data)
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop report3');
}
catch(ex){
console.log(ex);

}
finally{
console.log('finish');

}

},

refresh(h){

  

this.GetReport(h);

},

async save(){

console.log('start save setting');

  const requestOptions = {
    method: "Put",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(this.setting)
  };
                   await this.$api("/api/data/1",  requestOptions)
            .then( this.$router.go(-1))
                    .catch(error => {
                          console.error("There was an error!", error)
                    });

                    console.log('stop save setting');

},

async fetchSetting() {
      console.log("start2",this.$store.state.household.ID);
    
      this.$store.state.members='';
      console.log('before fetch setting');
      await this.$api(
        "/api/data/6/" + this.$store.state.terid
      )
        //.then((res) => res.json())
        .then((data) => (this.setting = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });

      console.log("after fetch setting");

  
    },




},

mounted(){

    this.fetchSetting();
}



}
</script>
